import { render } from "./CollectionsCandidatesView.vue?vue&type=template&id=776f5fa8&scoped=true"
import script from "./CollectionsCandidatesView.vue?vue&type=script&lang=js"
export * from "./CollectionsCandidatesView.vue?vue&type=script&lang=js"

import "./CollectionsCandidatesView.vue?vue&type=style&index=0&id=776f5fa8&scoped=true&lang=css"

import exportComponent from "/Users/chrisfinlayson/Desktop/WORK/riverhawk-nest/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-776f5fa8"]])

export default __exports__